module.exports = "/_next/static/pages/profile01/9c36def099050d27d28f53150f6f4519.png";